import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { useMemo } from 'react';
import { OrgUnitType } from '@retail/mgpris/config-types';
import { ConsumerType } from '@retail/sanity/data-access';

export const useConsumerType = (): ConsumerType => {
  const { orgUnitType } = useSelectedOrgUnit();

  return useMemo(() => {
    switch (orgUnitType) {
      case OrgUnitType.RETAIL_LOCATION:
      case OrgUnitType.RETAIL_DATAOWNER:
      case OrgUnitType.RETAIL_LOCATION_LIGHT:
      case OrgUnitType.RETAIL_LOCATION_LIGHT_PLUS:
      case OrgUnitType.RETAIL_LOCATION_UNDER_MASTER:
        return 'retail-member';
      case OrgUnitType.RETAIL_BRAND:
        return 'retail-pdm';
      case OrgUnitType.WHOLESALE_LOCATION:
      case OrgUnitType.WHOLESALE_PRICE_LIST:
        return 'wholesale';
      case OrgUnitType.WHOLESALE_BRAND:
        return 'wholesale-master';
      default:
        return 'retail-member';
    }
  }, [orgUnitType]);
};
